export const challengeOptions = [
  {
    value: "investTime",
    label: "Invest Time",
    children: [
      {
        value: "totalHours",
        label: "Total hours",
        children: [
          {
            value: "1H",
            label: "1 hour"
          },
          {
            value: "3H",
            label: "3 hours"
          },
          {
            value: "5H",
            label: "5 hours"
          },
          {
            value: "10H",
            label: "10 hours"
          },
          {
            value: "20H",
            label: "20 hours"
          },
          {
            value: "30H",
            label: "30 hours"
          },
          {
            value: "40H",
            label: "40 hours"
          },
          {
            value: "50H",
            label: "50 hours"
          },
          {
            value: "100H",
            label: "100 hours"
          },
          {
            value: "250H",
            label: "250 hours"
          },
          {
            value: "500H",
            label: "500 hours"
          },
          {
            value: "750H",
            label: "750 hours"
          },
          {
            value: "1000H",
            label: "1000 hours"
          },
          {
            value: "custom",
            label: "custom number of hours"
          }
        ]
      },
      {
        value: "totalSessions",
        label: "Total sessions",
        children: [
          {
            value: "1S",
            label: "1 session"
          },
          {
            value: "3S",
            label: "3 sessions"
          },
          {
            value: "5S",
            label: "5 sessions"
          },
          {
            value: "10S",
            label: "10 sessions"
          },
          {
            value: "20S",
            label: "20 sessions"
          },
          {
            value: "30S",
            label: "30 sessions"
          },
          {
            value: "40S",
            label: "40 sessions"
          },
          {
            value: "50S",
            label: "50 sessions"
          },
          {
            value: "100S",
            label: "100 sessions"
          },
          {
            value: "250S",
            label: "250 sessions"
          },
          {
            value: "500S",
            label: "500 sessions"
          },
          {
            value: "750S",
            label: "750 sessions"
          },
          {
            value: "1000S",
            label: "1000 sessions"
          },
          {
            value: "custom",
            label: "custom number of sessions"
          }
        ]
      },
      {
        value: "periodicHours",
        label: "Periodic hours",
        children: [
          {
            value: "1HourPerDayMonSun",
            label: "1 hour / day"
          },
          {
            value: "2HourPerDayMonSun",
            label: "2 hours / day"
          },
          {
            value: "3HourPerDayMonSun",
            label: "3 hours / day"
          },
          {
            value: "4HourPerDayMonSun",
            label: "4 hours / day"
          },
          {
            value: "1HourPerDayMonFri",
            label: "1 hours / day on Mon.- Fri."
          },
          {
            value: "2HourPerDayMonFri",
            label: "2 hours / day on Mon. - Fri."
          },
          {
            value: "3HourPerDayMonFri",
            label: "3 hours / day on Mon. - Fri."
          },
          {
            value: "4HourPerDayMonFri",
            label: "4 hours / day on Mon. - Fri."
          },
          {
            value: "1HourPerDaySatSun",
            label: "1 hours / day on Sat. - Sun."
          },
          {
            value: "2HourPerDaySatSun",
            label: "2 hours / day on Sat. - Sun."
          },
          {
            value: "3HourPerDaySatSun",
            label: "3 hours / day on Sat. - Sun."
          },
          {
            value: "4HourPerDaySatSun",
            label: "4 hours / day on Sat. - Sun."
          },
          {
            value: "custom",
            label: "Custom rule"
          }
        ]
      },
      {
        value: "periodicSessions",
        label: "Periodic Sessions",
        children: [
          {
            value: "1SessionPerDayMonSun",
            label: "1 Session / day"
          },
          {
            value: "2SessionsPerDayMonSun",
            label: "2 sessions / day"
          },
          {
            value: "3SessionsPerDayMonSun",
            label: "3 sessions / day"
          },
          {
            value: "4SessionsPerDayMonSun",
            label: "4 sessions / day"
          },
          {
            value: "1SessionsPerDayMonFri",
            label: "1 sessions / day on Mon.- Fri."
          },
          {
            value: "2SessionsPerDayMonFri",
            label: "2 sessions / day on Mon. - Fri."
          },
          {
            value: "3SessionsPerDayMonFri",
            label: "3 sessions / day on Mon. - Fri."
          },
          {
            value: "4SessionsPerDayMonFri",
            label: "4 sessions / day on Mon. - Fri."
          },
          {
            value: "1SessionsPerDaySatSun",
            label: "1 sessions / day on Sat. - Sun."
          },
          {
            value: "2SessionsPerDaySatSun",
            label: "2 sessions / day on Sat. - Sun."
          },
          {
            value: "3SessionsPerDaySatSun",
            label: "3 sessions / day on Sat. - Sun."
          },
          {
            value: "4SessionsPerDaySatSun",
            label: "4 sessions / day on Sat. - Sun."
          },
          {
            value: "custom",
            label: "Custom rule"
          }
        ]
      }
    ]
  },
  {
    value: "saveMoney",
    label: "Save Money",
    disabled: true,
    children: [
      {
        value: "total",
        label: "Total",
        children: [
          {
            value: "100 USD",
            label: "100USD"
          },
          {
            value: "500 USD",
            label: "500USD"
          },
          {
            value: "1000 USD",
            label: "1000USD"
          },
          {
            value: "customAmount",
            label: "custom amount"
          }
        ]
      },
      {
        value: "recurring",
        label: "Recurring"
      }
    ]
  },
  {
    value: "investMoney",
    label: "Invest Money",
    disabled: true,
    children: [
      {
        value: "total",
        label: "Total",
        children: [
          {
            value: "100 USD",
            label: "100USD"
          },
          {
            value: "500 USD",
            label: "500USD"
          },
          {
            value: "1000 USD",
            label: "1000USD"
          },
          {
            value: "customAmount",
            label: "custom amount"
          }
        ]
      },
      {
        value: "recurring",
        label: "Recurring"
      }
    ]
  },
  {
    value: "loseWeight",
    label: "Lose Weight",
    disabled: true,
    children: [
      {
        value: "total",
        label: "Total",
        children: [
          {
            value: "1kg",
            label: "1 kg"
          },
          {
            value: "2kg",
            label: "2 kg"
          },
          {
            value: "3kg",
            label: "3 kg"
          },
          {
            value: "5kg",
            label: "5 kg"
          },
          {
            value: "10kg",
            label: "10 kg"
          },
          {
            value: "15kg",
            label: "15 kg"
          },
          {
            value: "customWeight",
            label: "custom amount"
          }
        ]
      },
      {
        value: "recurring",
        label: "Recurring"
      }
    ]
  },
  {
    value: "custom",
    label: "Custom Challenge",
    disabled: true,
  }
];

export const challengeCustomFrequency = [
  {
    value: "perDay",
    label: "per day"
  },
  {
    value: "perWeek",
    label: "per week"
  },
  {
    value: "perMonth",
    label: "per month"
  },
  {
    value: "perQuarter",
    label: "per quarter"
  },
  {
    value: "perYear",
    label: "per year"
  }
];

export const challenges = [
  // sync
  {
    challengeId: 7,
    headline: {
      text: "Save 100€",
      fontFamily: "Roboto",
      fontSize: 15,
      x: 1000,
      y: 310,
      draggable: true,
      fill: "#ffffff"
    },
    image: {
      goalId: 1,
      image: null,
      src: "https://www.dumblittleman.com/wp-content/uploads/2017/08/ways-to-save-money-while-traveling.jpg",
      x: 200,
      y: 100,
      width: 232,
      height: 149,
      name: "challenge1img",
      draggable: true,
      shadowColor: "black",
      shadowBlur: 10,
      shadowOffset: { x: 10, y: 10 },
      shadowOpacity: 0.5,
      scaleX: 1,
      scaleY: 1
    },
    startDate: new Date(2018, 11, 11),
    endDate: new Date(2019, 6, 30),
    type: "hours until",
    amount: 5000,
    amountUnit: "currencyEUR",
    amountAchieved: 0,
    finishedPercent: 0,
    showCommitment: true,
    timeslotCollectionId: ""
  }
];
